import type React from "react";

import BenefitsBlock from "@/base/blocks/BenefitsBlock/BenefitsBlock";
import IntroductionBlocks from "@/base/blocks/IntroductionBlocks";
import { CmsBlock, CmsBlocks } from "@/base/components/Global";
import { CmsPage } from "@/base/components/Global/cmsPage";
import { fetchClubPage } from "@/store/cms";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

const ApolloClubPage: React.FC = () => {
  const clubPage = useAppSelector((state) => state.cms.clubPage);
  const dispatch = useAppDispatch();

  return (
    <CmsPage
      name="ApolloClubPage"
      pageStateMachine={clubPage}
      fetchPage={() => dispatch(fetchClubPage())}
    >
      {({ page }) => (
        <CmsBlocks>
          <CmsBlock hide={!page.benefitsBlock} addBreak>
            <BenefitsBlock block={page.benefitsBlock} />
          </CmsBlock>

          <CmsBlock hide={!page.apolloClubIntroductionBlocks} addBreak={false}>
            <IntroductionBlocks block={page.apolloClubIntroductionBlocks} />
          </CmsBlock>
        </CmsBlocks>
      )}
    </CmsPage>
  );
};

export default ApolloClubPage;
